<template>
    <div class="delete">

        <div v-if="passwordProtect" class="signup__container">

            <InputField
                    title="Hello"
                    type="text"
                    placeholder="football"
                    autocomplete="none"
                    autocapitalize="off"
                    v-model="pword"
                    :disabled="false"
                    :errored="false"
                    errorMessage=""
                ></InputField>

        </div>
        <div v-else >
            
            <!--Preloader-->
            <Preloader
                v-if="preloaderShow"
            ></Preloader>

            <!--Error-->
            <ErrorModal
                v-if="errorPopup"
                title="Error"
                message="An error occurred."
                @dismissError="dismissError"
            ></ErrorModal>

            <!-- Steps -->
            <div v-else class="signup__container">
                <div class="step__container">
                        
                        <!-- Title -->
                    <div class="step__title" ref="title">
                        <p>Delete Ohana User</p>
                    </div>

                    <!-- Subtitle -->
                    <div class="step__subtitle--delete" ref="subtitle">
                        <p>This will delete the user and all data associated with the user (contacts, messages, photos, Twilio Phone Number)</p>
                    </div>

                    <br>   
                    <br>
                    <br>

                    <InputField
                        title="UID"
                        type="text"
                        placeholder="abcd1234"
                        autocomplete="text"
                        autocapitalize="off"
                        v-model="uid"
                        :disabled=inputDisabled
                        :errored=uidFound
                        :errorMessage=errorMessage
                    ></InputField>

                    <!-- Need this somewhere or else computed will not run! -->
                    <p> {{ userGetter }} </p>
                    <p v-show="foundSubscriptionStatus" style="text-align: center; font-size: 1.5em; color: red; font-weight: 700;">THIS USER IS A SUBSCRIBER</p>

                    <div class="step__subtitle" ref="subtitle">
                        <p v-show="foundName">Name: &nbsp;&nbsp;&nbsp;&nbsp; {{ foundName }} </p>
                        <p v-show="foundEmail">Email: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ foundEmail }} </p>
                        <p v-show="foundNumber">Phone: &nbsp;&nbsp;&nbsp; {{ foundNumber }} </p>
                        <p v-show="foundContactsCount">Contacts: &nbsp;&nbsp;&nbsp; {{ foundContactsCount }} </p>
                        <p v-show="foundMessagesCount">Messages: &nbsp;&nbsp;&nbsp; {{ foundMessagesCount }} </p>
                    </div>
                    
                    <!-- Delete Button -->
                    <div class="step__button" ref="button">
                        <a href="#" @click.prevent="deleteUser" :class="{ 
                            'button--disable': !this.uidFound || this.buttonDisabled,
                            'button button--full': true 
                            }" >

                            <span class="button__title">Delete Account</span>
                            <span class="button__subtitle">This is PERMANENT</span>
                        </a>
                    </div>

                    <!-- Reset Button -->
                    <div v-if="!resetButtonDisabled" class="step__button--reset">
                        <a href="#" @click.prevent="resetClicked" :class="{ 
                            'button button--full': true 
                            }" >

                            <span class="button__title">Reset</span>
                        </a>
                    </div>
                </div>

                <div v-if="logEntries.length" class="log">

                    <hr/>
                    <p class="title">Log</p>

                    <ul>
                        <li v-for="entry in logEntries" v-bind:style="{ color: entry.color }"> {{ entry.message }} </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ErrorModal from '@/components/1-common/ErrorModal';
    import Preloader from '@/components/1-common/Preloader';
    import InputField from "@/components/1-common/InputField";
    import { usersCollection, messagesCollection } from '../../tools/firebaseConfig';
    import deleteAccount from '../../tools/deleteAccount';

    export default {
        name: 'Delete',
        components: {
            ErrorModal,
            Preloader,
            InputField
        },
        data() {
            return {
                errorPopup: false, // Show Error Popup
                preloaderShow: false, // Show Preloader
                uid: '',
                uidFound: false,
                errorMessage: '',
                foundName: '',
                foundEmail: '',
                foundNumber: '',
                foundContactsCount: '',
                foundMessagesCount: '',
                foundSubscriptionStatus: false,
                logEntries: [],
                inputDisabled: false,
                buttonDisabled: false,
                resetButtonDisabled: true,
                passwordProtect: true,
                pword: ''
            }
        },
        watch: {
            pword: function (newVal, oldVal) {

                if (this.pword == 'dangerzone') {    
                    this.passwordProtect = false;
                }
            }
        },
        computed: {
            userGetter: function () {

                this.foundName = ''
                this.foundEmail = ''
                this.errorMessage = ''
                this.foundNumber = ''
                this.foundContactsCount = ''
                this.foundMessagesCount = ''
                this.foundSubscriptionStatus = false

                // Protect against empty uid
                if (this.uid == '') {
                    return
                }

                let userRef = usersCollection.child(this.uid)
                userRef.once('value')
                .then(userFound => {
                    
                    // Make sure returned object is one currently in box
                    if (userFound.key != this.uid) {
                        return;
                    }

                    this.uidFound = userFound.exists();

                    // Exit if doesn't exist
                    if (!userFound.exists()) {
                        this.errorMessage = 'User \"' + this.uid + '\" not found'
                        return;
                    }

                    this.errorMessage = '';

                    this.foundName = userFound.val().name;
                    this.foundEmail  = userFound.val().email;
                    this.foundNumber = userFound.val().phone || 'nil';
                    this.foundSubscriptionStatus = userFound.val().subscriptionStatus || false;

                    if (userFound.val().contacts != null) {
                        const contactsLength = Object.keys(userFound.val().contacts).length;
                        this.foundContactsCount = contactsLength.toString();
                    } else {
                        this.foundContactsCount = 'NONE'
                    }

                    // Get Messages
                    if (userFound.val().phone != null) {
                        messagesCollection.child(this.foundNumber).once('value')
                        .then(messagesFound =>{
                            if (messagesFound.exists()) {
                                // console.log(messagesFound.val());
                                const messageRecips = Object.keys(messagesFound.val()).length;
                                // console.log(messageRecips)
                                const messagesArrayOfArrays =  Object.values(messagesFound.val());

                                var allMessages = [];
                                messagesArrayOfArrays.forEach(array => {
                                    const actualArray = Object.keys(array)
                                    allMessages = allMessages.concat(actualArray)
                                })

                                console.log(allMessages);

                                this.foundMessagesCount = allMessages.length.toString();



                            } else {

                                this.foundMessagesCount = 'NONE'
                            }
                        })
                        .catch(error => {
                            console.log('error looking for messages:')
                            console.log(error)
                        })

                    } else {
                        this.foundMessagesCount = 'NONE'
                    }

                    console.log('user found!:')
                    console.log(userFound.exists())
                    console.log(userFound.val().email)
                    // console.log(userRef.toJSON())
                })
                .catch(error => {
                    console.log('uhhh, I think not found?')
                    console.log(error)
                })

                return ''
            }
        },
        methods: {

            deleteUser() {

                if (this.buttonDisabled) {
                    console.log('button disabled');
                    window.alert("Please clear current delete.")
                    return;
                }

                if (!this.uidFound) {
                    console.log('uid not found!');
                    window.alert("UID not found.");
                    return;
                }

                if (this.isProtectedUser(this.uid)) {
                    console.log('TRIED TO DELETE PROTECTED USER!')
                    window.alert("THIS USER IS PROTECTED! Ask Vince to delete.");
                    return;
                }

                const confirmed = confirm("Are you sure you want to delete this user?\nThis operation is permanent!");
                if (!confirmed) {
                    console.log('operation cancelled');
                    return;
                }

                this.inputDisabled = true;
                this.buttonDisabled = true;
                deleteAccount(this.uid, newLogEntry => {
                    this.logEntries.push(newLogEntry);
                })
                .then(() => {
                    console.log('done')
                    this.resetButtonDisabled = false;
                })
            },

            resetClicked() {

                if (this.resetButtonDisabled) {
                    console.log('button is disabled, not sure how it was clicked...')
                    return;
                }

                
                this.uid = ''
                this.uidFound = false
                this.errorMessage = ''
                this.foundName = ''
                this.foundEmail = ''
                this.foundNumber = ''
                this.foundContactsCount = ''
                this.foundMessagesCount = ''
                this.foundSubscriptionStatus = false
                this.logEntries = []
                this.inputDisabled = false
                this.buttonDisabled = false
                this.resetButtonDisabled = true
            },

            showLoading() {
                // console.log('showLoading called');
                this.preloaderShow = true;
            },

            dismissLoading() {
                console.log('dismissing loading');
                this.preloaderShow = false;
            },

            showError(message) {
                console.log('show error called');
                // this.error_message = message;
                this.errorPopup = true;
            },

            dismissError() {
                console.log('dismissing error');
                this.errorPopup = false;
            },

            isProtectedUser(uid) {

                const protectedUIDs = [
                    '88n3CkBsoiXdU8E5LYPi1s1tT6d2',
                    'JkMG1WN3ZeZZo3fsdjmtMve8NFN2',
                    'UmAroqbKDDOT4SV1vDolpVCQHiu2',
                    'bdfGfzR2kqgresVhVkL6wvzsfNu1',
                ]

                return protectedUIDs.includes(uid)
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Delete.vue?716659f6